import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Block, Link } from '@klp/design';
import { LocalLoader } from '@klp/design/Loader';
import { useSelector } from 'react-redux';

import { contextSelectors } from '@klp/contextSelector';
import { SakSummaryStatistics } from './SakSummaryStatistics';
import {
    useGetSakStatisticsQuery,
    useGetSwedishSakStatisticsQuery,
} from './services/rtkApi';
import { getConfig } from '@klpkonsern/appconfig';
import { useCurrentUser } from '@klp/auth';
import { usePortfolio } from '@klp/portfolio/store';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    title: {
        textTransform: 'uppercase',
    },
}));

export default function SakSummaryView() {
    const classes = useStyles();

    const { selectedContext } = useSelector(contextSelectors);
    const { currentUser, isEDAdmin } = useCurrentUser();
    const { portfolio } = usePortfolio();
    const { i18n } = useTranslation();

    const isSwedish =
        i18n.language === 'sv' || selectedContext?.id?.startsWith('S');
    const sakEmailParameter = isEDAdmin
        ? portfolio?.brukerId
        : currentUser?.epost;
    const validSakParameters = Boolean(
        selectedContext?.id || sakEmailParameter,
    );

    const { data: sakStatistics, isLoading: sakStatisticsLoading } =
        useGetSakStatisticsQuery(
            {
                byggnummer: selectedContext?.id,
                email: sakEmailParameter,
            },
            {
                skip: isSwedish || !validSakParameters,
            },
        );

    const {
        data: swedishSakStatistics,
        isLoading: swedishSakStatisticsLoading,
    } = useGetSwedishSakStatisticsQuery(
        {
            byggnummer: selectedContext?.id,
            email: sakEmailParameter,
        },
        { skip: !isSwedish || !validSakParameters },
    );

    const getSakUrl = () => {
        const base = isSwedish
            ? getConfig('WEBAPP_APP_SWEDISH_KUNDEPORTAL_URL')
            : getConfig('WEBAPP_APP_KUNDEPORTAL_URL');

        if (selectedContext?.id) {
            return `${base}eiendom/${selectedContext.id}/sak`;
        }
        return `${base}sak`;
    };

    const sakIsLoading = sakStatisticsLoading || swedishSakStatisticsLoading;
    const currentStatistics = isSwedish ? swedishSakStatistics : sakStatistics;

    return (
        <>
            <Block
                marginTop="compact"
                display="inline"
                klpTypographyVariant="xsmall"
                className={classes.title}
                translation="frontPage.sak.subtitle"
            />
            <LocalLoader isLoading={sakIsLoading} data-testid="Loader">
                <SakSummaryStatistics statistics={currentStatistics} />
            </LocalLoader>
            <Block paddingTop="tiny">
                <Link
                    externalLink={true}
                    translation="frontPage.sak.actionButtonText"
                    onClick={() => window.open(getSakUrl(), '_blank')}
                />
            </Block>
        </>
    );
}
